import React, { useState, useEffect, useRef } from "react";
import AdminAppBar from "../../adminComponents/AdminAppBar";
import BackArrows from "../../Form/BackArrow/BackArrows";
import { ToastContainer } from "react-toastify";
import { IoSearch } from "react-icons/io5";
import { MdFilterListAlt } from "react-icons/md";
import { Sidebar } from "primereact/sidebar";
import {
  
  leadStatusMap,
  statusIcons,
} from "../../../Enum";
import {interestLevel , getStatusBgColor} from '../../../Enum/LeadEnumConstants'
import { FaChevronDown } from "react-icons/fa";
import Select, { components } from "react-select";
import LocationService from "../../Services/LocationService";
import teamService from "../../Services/TeamService";
import leadSourceService from "../../Services/LeadSourceService";
import userServices from "../../Services/UserService";
import LeadTable from "../../Form/LeadTable/LeadTable";
import LeadDbService from "../../Services/LeadDbService";

import { useLocation, useNavigate } from "react-router-dom";
// import ReasignModal from "./ReasignModel";
import { showErrorToast, showInfoToast, showSuccessToast } from "../../Constant/Notification";
import { teamIds, teamList } from "../../../utils/storage";
import { format } from "date-fns";
import CustomHeading from "../../common/CustomHeading";
import { getBasePathByUserRole } from "../../../utils/roleRoutes";
import AssignSummaryFilter from "./AssignSummaryFilter";
import CustomTruncatedText from "../../common/CustomTruncatedText";
import { formatToIndianDate } from "../../../utils/dateFormatter";
import { status } from "../../../Enum/LeadEnumConstants";
import CustomButton from "../../common/CustomButton";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import Loader from "../../Constant/Loader";
import { managementDepartmentLabel, salesDepartmentLabel } from "../../../GlobalSetupComponents/Enum/DepartmentEnum";
import TeamService from "../../../GlobalSetupComponents/Services/TeamService";
import UserService from "../../../GlobalSetupComponents/Services/UserService";
const AssignSummaryList = () => {
  const location = useLocation();
  console.log(location.state);

  // User Info to user id and team Id

  const userId = location.state?.userId || null;
  const teamId = location.state?.teamId || null;
  const filterOpen = location.state?.filterOpen;

  console.log(
    "Team Id",
    Array.isArray(teamIds) && teamIds.length > 0 ? teamIds[0] : "No teamId"
  );

  const defaultTeamId =
    Array.isArray(teamIds) && teamIds.length > 0 ? teamIds[0] : teamId;

  const [filterVisible, setFilterVisible] = useState(filterOpen || false);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [selectedLevel, setSelectedLevel] = useState(null);
  const [leadSource, setLeadSource] = useState([]);

  const [optionLocation, setOptionLocation] = useState([]);
  const [leadSources, setLeadSources] = useState([]);
  const [teams, setTeams] = useState([]);
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(userId || null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [menuOpen, setMenuOpen] = useState(false);
  const [selectedTeam, setSelectedTeam] = useState(defaultTeamId || null);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [startType, setStartType] = useState("text");
  const [endType, setEndType] = useState("text");
  const [searchQuery, setSearchQuery] = useState("");
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [leads, setLeads] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [nextPageToken, setNextPageToken] = useState(null);
  const [prevPageToken, setPrevPageToken] = useState(null);
  const [hasMoreLeads, setHasMoreLeads] = useState(false);
  const [pageSize, setPageSize] = useState(10);
  const [leadCache, setLeadCache] = useState({});
  const navigate = useNavigate();
  const userData = JSON.parse(localStorage.getItem("userData"));
  const userRole = userData?.user?.role;
  const [showReassignModal, setShowReassignModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingDownload , setLoadingDownload] = useState(false);
  const [teamToggle, setTeamToggle] = useState(true);
  const [selectedLeadSourceId, setSelectedLeadSourceId] = useState(null);



  const customStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: "transparent",
      border: "none",
      boxShadow: "none",
    }),
  };

  const getBackgroundClass = (label) => {
    switch (label.toLowerCase()) {
      case "gold":
        return "bg-gradient-to-b from-[#FFB947] to-[#ECCD90] bg-clip-text text-transparent";
      case "silver":
        return "bg-gradient-to-b from-[#B6B6B6] to-[#E8E8E8] bg-clip-text text-transparent";
      case "bronze":
        return "bg-gradient-to-b from-[#BA7E5E] via-[#FF9F6B] to-[#411904] bg-clip-text text-transparent";
      case "diamond":
        return "bg-gradient-to-b from-[#0563FF] to-[#4085F8] bg-clip-text text-transparent";
      default:
        return "text-black";
    }
  };

  const handleLeadInfo = (lead) => {
    console.log("Lead object:", lead);
    console.log("Lead ID:", lead.id);
    let path = "";
    if (userRole === "Admin") {
      path = `/admin/lead-info/${lead.id}`;
    } else if (userRole === "CMO") {
      path = `/cmo/lead-info/${lead.id}`;
    } else if (userRole === "MD") {
      path = `/md/lead-info/${lead.id}`;
    } else if (userRole === "BOD") {
      path = `/bod/lead-info/${lead.id}`;
    }
    navigate(path, { state: { lead } });
  };

  const columns = [
    {
      key: "name",
      title: "Name",
      render: (text, record) => (
        <div
          onClick={() => handleLeadInfo(record)}
          title={text}
          className="text-blue-500 line-clamp-2 capitalize truncate text-center text-wrap cursor-pointer "
        >
          {text}
        </div>
      ),
    },
    {
      key: "phoneNumber",
      title: "Phone Number",
      render: (text, record) => (
        <div className=" line-clamp-1 capitalize truncate text-center text-wrap  ">
          +{record.countryCode} {record.phoneNumber}
        </div>
      ),
    },
    {
      key: "status",
      title: "Status",
      render: (value) => {
        const matchedStatus = statusIcons.find((item) => item.label === value);
        if (!matchedStatus)
          return (
            <span className="text-gray-600 text-center block">Unknown</span>
          );

        return (
          <div
            className={`${getStatusBgColor(
              matchedStatus?.label
            )} flex justify-center items-center gap-2 text-center rounded-full`}
          >
            <img
              src={matchedStatus.image}
              alt={matchedStatus.label}
              className="w-5 h-5"
            />
            <span className="text-gray-700">{matchedStatus.label}</span>
          </div>
        );
      },
    },
    {
      key: "leadQuality",
      title: "Lead Quality",
      render: (value) => {
        const matchedQuality = interestLevel.find(
          (item) => item.label === value
        );

        return (
          <div className="flex justify-center items-center gap-2 text-center">
            <img
              src={matchedQuality.image}
              alt={matchedQuality.label}
              className="w-5 h-5"
            />
            <span className={`${getBackgroundClass(matchedQuality.label)}`}>
              {matchedQuality.label}
            </span>
          </div>
        );
      },
    },
    {
      key: "location",
      title: "Location",
      render: (value) => {
        const firstLocation = value?.[0]?.name || "No Location";
        const extraCount = value?.length > 1 ? ` +${value.length - 1}` : "";
        const fullTitle = value?.map((loc) => loc.name).join(", ");

        return (
          <span
            className="inline-block text-center  truncate whitespace-nowrap overflow-hidden"
            title={fullTitle}
          >
            {firstLocation}
            <span className="text-blue-500">{extraCount}</span>
          </span>
        );
      },
    },
    {
      key: "assignedTeam",
      title: "Team",
      render: (value) => (
        <div
          title={value}
          className=" line-clamp-1 capitalize truncate text-center text-wrap cursor-pointer"
        >
        {value}
        </div>
      ),
    },
    {
      key: "assignedUser",
      title: "Assigned To",
      render: (value) => (
        <div
          title={value}
          className="line-clamp-1 capitalize truncate text-center text-wrap cursor-pointer"
        >
          {value}
        </div>
      ),
    },
  ];

  const formatDate = (date) => {
    const d = new Date(date);
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    const year = d.getFullYear();
    return `${month}-${day}-${year}`;
  };

  const formattedStartDate = startDate ? formatDate(startDate) : "";
  const formattedEndDate = endDate ? formatDate(endDate) : "";

  const removalCountRef = useRef(0);

  const applyFilter = (removalChip) => {
    if (startDate && !endDate) {
      showErrorToast("End Date is required when Start Date is selected.");
      return;
    }
   

    console.log("applyFilter", removalChip);

    // Compute what the new state will be after the chip is removed
    const level = removalChip === "quality" ? null : selectedLevel;
    const status = removalChip === "status" ? null : selectedStatus;
    const location = removalChip === "location" ? null : leadSource;
    const team = removalChip === "team" ? null : selectedTeam;
    const user = removalChip === "user" ? null : selectedUser;
    const start = removalChip === "startDate" ? null : formattedStartDate;
    const end = removalChip === "startDate" ? null : formattedEndDate;

    if (teamToggle) {
      const noFiltersSelected =
        !level &&
        !status &&
        (!location || location.length === 0) &&
        !team &&
        !user &&
        !start &&
        !end;

      if (noFiltersSelected) {
        showInfoToast("No filters selected. Please apply at least one.");

        setLeads([]);
        setHasMoreLeads(false);
        setLeadCache({});
        return;
      }
    }

    const newPageSize = 10;
    setLeadCache({});

    handleApplyFilter(null, "reset", newPageSize, 1, removalChip);
  };

  const handleApplyFilter = async (
    pageToken = null,
    direction = "next",
    limitOverride = null,
    overridePage = null,
    removalChip,
  ) => {
    setLoading(true);
    console.log("handleApplyFilter", removalChip);
    try {
      let targetPage = overridePage ?? currentPage;

      if (direction === "next") {
        targetPage += 1;
      } else if (direction === "previous") {
        targetPage = Math.max(targetPage - 1, 1);
      } else if (direction === "reset") {
        targetPage = 1;
      }

      if (leadCache[targetPage] && !removalChip) {
        const cached = leadCache[targetPage];
        setLeads(cached.leads);
        setNextPageToken(cached.next);
        setPrevPageToken(cached.prev);
        setHasMoreLeads(!!cached.next);
        setCurrentPage(targetPage);
        return;
      }

      const body = {
        searchKey: searchQuery.trim() || null,
      //  status: removalChip == "status" ? null : selectedStatus || null,
      //  quality: removalChip == "quality" ? null : selectedLevel?.label || null,
     //   location: removalChip == "location" ? null : leadSource?.value || null,
        teamId: removalChip == "team" ? null : selectedTeam || defaultTeamId,
   //     teamStatus: teamToggle,
     //   leadSourceId: leadSource?.value || null,
        userId: removalChip == "user" ? null : selectedUser || null,
        startDate: removalChip == "startDate" ? null : formattedStartDate || null,
        endDate: removalChip == "startDate" ? null : formattedEndDate || null,
        limit: limitOverride ?? pageSize,
        next: direction === "next" ? pageToken : null,
        previous: direction === "previous" ? pageToken : null,
        direction,
      };

      const filterData = await LeadDbService.getLeadAssignSummaryList(body);
      const newLeads = filterData.data.leads;
      const newNext = filterData.data.next;
      const newPrev = filterData.data.prev;

      setLeadCache((prev) => ({
        ...prev,
        [targetPage]: {
          leads: newLeads,
          next: newNext,
          prev: newPrev,
        },
      }));

      setFilterVisible(false);
      setLeads(newLeads);
      setNextPageToken(newNext);
      setPrevPageToken(newPrev);
      setHasMoreLeads(!!newNext);
      setCurrentPage(targetPage);
    } catch (error) {
      console.error("Error fetching filtered leads:", error);
    } finally {
      setLoading(false);
    }
  };

  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    handleApplyFilter(null, "reset", pageSize, 1, true);
  }, [pageSize]);

  const handlePageChange = (tokenOrValue, direction) => {
    console.log(tokenOrValue);
    if (direction === "size") {
      const newPageSize = parseInt(tokenOrValue, 10);
      setPageSize(newPageSize);
      setCurrentPage(1);
      setLeadCache({});
      setNextPageToken(null);
      setPrevPageToken(null);
      handleApplyFilter(null, "reset", newPageSize, 1);
    } else if (direction === "next") {
      setCurrentPage((prev) => prev + 1);
      handleApplyFilter(nextPageToken, "next");
    } else if (direction === "previous") {
      setCurrentPage((prev) => Math.max(prev - 1, 1));
      handleApplyFilter(prevPageToken, "previous");
    }
  };

  const clearFilterData = () => {
    return new Promise((resolve) => {
      setSelectedStatus("");
      setSelectedLevel(null);
      setLeadSource([]);
      if(userRole !== "BOD")

        {
            setSelectedTeam("");
        }
     
      setSelectedUser("");
      setStartDate("");
      setEndDate("");
      setErrors({});
      resolve();
    });
  };

  const handleClearAndApplyFilter = async () => {
    await clearFilterData();
    applyFilter();
  };

  const handleSelectionChange = (selectedIds) => {
    setSelectedRows(selectedIds);
    console.log("All selected IDs:", selectedIds);
  };

  useEffect(() => {
    (async () => {
      try {
        const response = await TeamService.getDepartmentTeamList({
          department: salesDepartmentLabel
        });
        const data = response.data.map((list)=>({
          teamId: list.value,
          name: list.label
        })) || [];
        setTeams(data);
      } catch (error) {
        console.error("Error fetching teams:", error);
      }
    })();
  }, []);

   const fetchTeamUsers = async () => {
      if (!selectedTeam) {
        setUsers([]);
        return;
      }

      setIsLoading(true);
      try {
        const selected = selectedTeam || defaultTeamId;
       const response = await UserService.getDepartmentWithTeamMembers({
                 
                 departmentNames: [managementDepartmentLabel , salesDepartmentLabel],
                 teamId: selected,
               });
               const data = response.data?.users;
       
               const combinedUsers = data.map((user) => ({
                 id: user.value,
                 name: user.label,
               }));
       
               const finalUsers = combinedUsers.length > 0 ? combinedUsers : [];
               setUsers(finalUsers);
      } catch (error) {
        console.error("Error fetching team users:", error);
        setUsers([]);
      } finally {
        setIsLoading(false);
      }
    };

  useEffect(() => {
   

    fetchTeamUsers();
  }, [selectedTeam]);

  const handleFilterLeads = () => {
    setFilterVisible(true);
  };

  const handleStatusChange = (e) => {
    console.log(e);
    setSelectedStatus(e);
  };

  const handleSelectChange = (selectedOption) => {
    console.log(selectedOption);
    setSelectedLevel(selectedOption);
  };

  const handleTeamChange = (value) => {
    setSelectedTeam(value);
    setSelectedUser("");
  };

  const handleSearchLead = () => {
    setLeadCache({});
  
if(userRole === "BOD"){
  const level = selectedLevel;
  const status = selectedStatus;
  const location = leadSource;

  const user = selectedUser;
  const start = formattedStartDate;
  const end = formattedEndDate;

  const noFiltersSelected =
    !level &&
    !status &&
    (!location || location.length === 0) &&
 
    !user &&
    !start &&
    !end;
console.log("BOD")

  if (searchQuery.trim() !== "" || !noFiltersSelected) {
    handleApplyFilter();
  }
}else{
  const level = selectedLevel;
  const status = selectedStatus;
  const location = leadSource;
  const team = selectedTeam;
  const user = selectedUser;
  const start = formattedStartDate;
  const end = formattedEndDate;

  const noFiltersSelected =
    !level &&
    !status &&
    (!location || location.length === 0) &&
    !team &&
    !user &&
    !start &&
    !end;
    console.log("Admin")

  if (searchQuery.trim() !== "" || !noFiltersSelected) {
    handleApplyFilter();
  }
}
  };
  

  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <FaChevronDown className="text-customGreen" />
      </components.DropdownIndicator>
    );
  };

  const getLocalDate = () => {
    const now = new Date();
    const offset = now.getTimezoneOffset();
    const localDate = new Date(now.getTime() - offset * 60 * 1000);
    return localDate.toISOString().split("T")[0];
  };

  const path = getBasePathByUserRole();

  const handleRemoveStatus = () => {
    setSelectedStatus(null);

    applyFilter("status");
  };

  const handleRemoveLevel = () => {
    setSelectedLevel(null);
    applyFilter("quality");
  };

  const handleRemoveLocation = (loc) => {
    setLeadSource(null);
    applyFilter("location");
  };

  const handleRemoveTeam = () => {
    setSelectedTeam(null);
    if(selectedUser)
    {
      fetchTeamUsers();
    }
   // setSelectedUser(null);
    applyFilter("team");
  };

  const handleRemoveUser = () => {
    setSelectedUser(null);
    applyFilter("user");
  };

  const handleRemoveDate = () => {
    setStartDate(null);
    setEndDate(null);
    applyFilter("startDate");
  };

  const handleAssignTeam = () => {
    if (selectedRows.length > 300) {
      showInfoToast("You can't assign more than 300 leads at a time");
      return;
    }

    navigate(`${path}/lead/reassign`, {
      state: {
        leadSourceId: selectedLeadSourceId,
        assignStatus: true,
        teamId: selectedTeam,
        leadCount: selectedRows.length,
        leadIds: selectedRows,
        teamStatus: teamToggle,
      },
    });
  };

  const handleDownloadReport = async () => {



    setLoadingDownload(true)
    try{

      const body ={
        teamId:  selectedTeam || defaultTeamId,
        userId: selectedUser || null,
        startDate: formattedStartDate || null,
        endDate:  formattedEndDate || null,


      }
      const response = await LeadDbService.getLeadAssignSummaryReportDownload(body)

      if(response.status === 200){


        const reportData = response.data?.data;
        if (!Array.isArray(reportData) || reportData.length === 0) {
          showErrorToast("No data found for the selected criteria.");
          return;
        }
  
        
  
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Report");
  
        const headers = Object.keys(reportData[0]);
        worksheet.columns = headers.map((header) => ({
          header: header.trim(),
          key: header,
          width: 20,
        }));
  
        worksheet.getRow(1).eachCell((cell) => {
          cell.font = { bold: true, color: { argb: "FF000000" } };
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "C4C6E4" },
          };
          cell.alignment = { vertical: "middle", horizontal: "center" };
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
        });
  
        reportData.forEach((item) => {
          worksheet.addRow(item);
        });
  
        worksheet.eachRow((row, rowNumber) => {
          if (rowNumber !== 1) {
            row.height = 30;
            row.eachCell((cell) => {
              cell.alignment = { vertical: "middle", horizontal: "center" };
              cell.border = {
                top: { style: "thin" },
                left: { style: "thin" },
                bottom: { style: "thin" },
                right: { style: "thin" },
              };
            });
          } else {
            row.height = 60;
          }
        });
  
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        if(!startDate && !endDate)
          saveAs(blob, `Assign Summary Report.xlsx`);
        else{
          saveAs(blob, `Assign Summary Report${formatDate(startDate)} To ${formatDate(endDate)}.xlsx`);
        }
        
       
        showSuccessToast("Successfully downloaded");
      }

  


    }catch(error)
    {
      console.log(error);
    }finally{
      setLoadingDownload(false)
    }

  }


  console.log("Selected user ID" , selectedUser);


  


  return (
    <div className="pt-14 bg-appGrayBackground ">
      <AdminAppBar />
      <ToastContainer />
      {loadingDownload && (
  <Loader/>
)}
      <div className="mt-[50px] px-6">
        <div className="flex flex-col gap-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center   gap-5">
              <CustomHeading title={"Assign Summary"} isIcon={true} />
            </div>

            <div className="flex items-center gap-5">
              {/* Status */}
              {selectedStatus && (
                <div className="flex items-center gap-2 bg-customGreen text-white px-3 py-1 rounded-full text-sm">
                  <span>{selectedStatus}</span>
                  <button onClick={handleRemoveStatus}>✖</button>
                </div>
              )}

              {/* Interest Level */}
              {selectedLevel && (
                <div className="flex items-center gap-2 bg-customGreen text-white px-3 py-1 rounded-full text-sm">
                  <span>{selectedLevel.label}</span>
                  <button onClick={handleRemoveLevel}>✖</button>
                </div>
              )}

              {/* Locations */}
              {leadSource?.label && (
                <div className="flex items-center gap-2 bg-customGreen text-white px-3 py-1 rounded-full text-sm">
                  <span>{leadSource?.label}</span>
                  <button onClick={() => handleRemoveLocation()}>✖</button>
                </div>
              )}

              {/* Team */}
              {userRole !== "BOD" && (
                <>
                  {selectedTeam && (
                    <div className="flex items-center gap-2 bg-customGreen text-white px-3 py-1 rounded-full text-sm">
                      <span>
                        {teams.find((team) => team.teamId === selectedTeam)
                          ?.name || selectedTeam}
                      </span>
                      <button onClick={handleRemoveTeam}>✖</button>
                    </div>
                  )}
                </>
              )}

              {/* User */}
              {selectedUser && (
                <div className="flex items-center gap-2 bg-customGreen text-white px-3 py-1 rounded-full text-sm">
                  <span>
                    {users.find((user) => user.id === selectedUser)?.name ||
                      selectedUser}
                  </span>
                  <button onClick={handleRemoveUser}>✖</button>
                </div>
              )}

              {/* Date Range */}
              {(startDate || endDate) && (
<>
<div className="flex items-center gap-2 bg-customGreen text-white px-3 py-1 rounded-full text-sm">
                  <span>

                {`Date: ${formatToIndianDate(
                  startDate
                )} - ${formatToIndianDate(endDate)}`}
                  </span>

                  <button onClick={handleRemoveDate}>✖</button>
                </div>



</>
              )}

<div>
<CustomButton
label={"Download"}
isDisabled={
  loadingDownload ||
  selectedTeam === null &&
  selectedUser === null &&
  !startDate &&
  !endDate
}

onClick={handleDownloadReport}
/>
</div>
            </div>
          </div>
        </div>
      </div>

      <AssignSummaryFilter
        visible={filterVisible}
        onHide={() => setFilterVisible(false)}
        status={status}
        selectedStatus={selectedStatus}
        handleStatusChange={handleStatusChange}
        interestLevel={interestLevel}
        selectedLevel={selectedLevel}
        handleSelectChange={handleSelectChange}
        optionLocation={optionLocation}
        menuOpen={menuOpen}
        setMenuOpen={setMenuOpen}
        customStyles={customStyles}
        getBackgroundClass={getBackgroundClass}
        teams={teams}
        selectedTeam={selectedTeam}
        DropdownIndicator={DropdownIndicator}
        handleTeamChange={handleTeamChange}
        errors={errors}
        users={users}
        selectedUser={selectedUser}
        setSelectedUser={setSelectedUser}
        isLoading={isLoading}
        startDate={startDate}
        setStartDate={setStartDate}
        startType={startType}
        setStartType={setStartType}
        endDate={endDate}
        setEndDate={setEndDate}
        endType={endType}
        setEndType={setEndType}
        getLocalDate={getLocalDate}
        handleApplyFilter={applyFilter}
        clearFilters={handleClearAndApplyFilter}
      />

      <div className="mt-[40px] px-6">
        <LeadTable
          data={leads}
          columns={columns}
          onPageChange={handlePageChange}
          selectedRows={selectedRows}
          disPlay={false}
          onSelectionChange={handleSelectionChange}
          currentPage={currentPage}
          setSearchQuery={setSearchQuery}
          handleSearchLead={handleSearchLead}
          //   handleReasignTeam={handleReasignTeam}
          handleAssignTeam={handleAssignTeam}
          searchQuery={searchQuery}
          loading={loading}
          pageSize={pageSize}
          nextPageToken={nextPageToken}
          prevPageToken={prevPageToken}
         
          hasMoreLeads={hasMoreLeads}
          handleFilterLeads={handleFilterLeads}
        />
 
      </div>
    </div>
  );
};

export default AssignSummaryList;
